import React from "react";
import EmptyState from "@/components/jea/EmptyState";

/**
 * Generic placeholder route used for every sidebar item that isn't built yet.
 */
const PlaceholderPage = ({ icon, title, description, testid = "placeholder-page" }) => {
  return (
    <div className="space-y-4" data-testid={testid}>
      <div className="space-y-1">
        <div className="jea-caption">Coming soon</div>
        <h1 className="text-[32px] font-extrabold tracking-[-0.02em] text-white">{title}</h1>
      </div>
      <EmptyState icon={icon} title={title} description={description} testid={`${testid}-empty`} />
    </div>
  );
};

export default PlaceholderPage;
